export default {
  name: 'GraphicRiver',
  abbreviation: 'GR',
  domain: 'graphicriver.net',
  google_analytics_id: 'UA-11834194-6',
  google_remarketing_label: 'hJ8ZCL2AugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'eg. brochure template',
  assets_domains: {
    item_thumbnail: 'thumb-gr.s3.envato.com',
    item_image: 'image-gr.s3.envato.com'
  },
  feeds_categories: [
    '/category/graphics',
    '/category/print-templates',
    '/category/epublishing',
    '/category/textures',
    '/category/vectors',
    '/category/infographics',
    '/category/add-ons',
    '/category/isolated-objects',
    '/category/icons',
    '/category/presentation-templates',
    '/category/fonts',
    '/category/web-elements',
    '/category/logo-templates',
    '/category/t-shirts',
    '/category/game-assets'
  ]
}



// WEBPACK FOOTER //
// ./config/sites/graphicriver.js